var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-telegram 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2354 0.960938C18.3329 0.960938 23.2754 5.9035 23.2754 12.0009C23.2754 18.0984 18.3329 23.0409 12.2354 23.0409C6.138 23.0409 1.19544 18.0984 1.19544 12.0009C1.19544 5.9035 6.138 0.960938 12.2354 0.960938ZM16.0438 16.5009C16.2468 15.8779 17.1982 9.66862 17.3158 8.4451C17.3513 8.07454 17.2342 7.8283 17.0047 7.71838C16.7273 7.58494 16.3164 7.65166 15.8398 7.8235C15.186 8.05918 6.82824 11.6078 6.34536 11.8133C5.88744 12.0077 5.45448 12.2198 5.45448 12.527C5.45448 12.743 5.58264 12.8645 5.93592 12.9907C6.3036 13.1217 7.22952 13.4025 7.77624 13.5533C8.3028 13.6987 8.90232 13.5725 9.23832 13.3637C9.59448 13.1424 13.7047 10.392 13.9999 10.151C14.2946 9.91006 14.5298 10.2187 14.2889 10.4601C14.0479 10.7011 11.2265 13.4395 10.8545 13.8187C10.4028 14.279 10.7234 14.7561 11.0263 14.9472C11.3724 15.1651 13.8612 16.8345 14.2361 17.1024C14.611 17.3702 14.9911 17.4917 15.3391 17.4917C15.6871 17.4917 15.8705 17.0333 16.0438 16.5009Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.ceeafc00122963fec19617846d8064c9.svg";
export { ForwardRef as ReactComponent };